import { render, staticRenderFns } from "./DemandEdit.vue?vue&type=template&id=62127c58"
import script from "./DemandEdit.vue?vue&type=script&lang=js"
export * from "./DemandEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports